import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GrnService } from '@shared/services/grn.service';

@Component({
  selector: 'app-purchase-history-stat',
  imports: [CommonModule],
  templateUrl: './purchase-history-stat.component.html',
  styleUrl: './purchase-history-stat.component.scss'
})
export class PurchaseHistoryStatComponent implements OnInit {
  thisMonthStats: PurchaseHistoryStat = {
    date: new Date(),
    grnCount: 0,
    itemCount: 0,
    unitCount: 0,
    totalCost: 0
  }
  lstMonthStats: PurchaseHistoryStat = {
    date: new Date(),
    grnCount: 0,
    itemCount: 0,
    unitCount: 0,
    totalCost: 0
  }
  last6MonthsStats: PurchaseHistoryStat = {
    date: new Date(),
    grnCount: 0,
    itemCount: 0,
    unitCount: 0,
    totalCost: 0
  };

  loadingThisMonth: boolean = true;
  loadingLastMonth: boolean = true;
  loadingLast6Months: boolean = true;

  constructor(private grnService: GrnService) { }

  ngOnInit() {
    this.loadThisMonthStats();
    this.loadLastMonthStats();
    this.loadLast6MonthsStats();
  }

  loadThisMonthStats() {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth(), 1);
    const to = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);

    this.grnService.getStats(from, to).subscribe({
      next: (stats) => {
        this.thisMonthStats = { ...stats, date: from };
        this.loadingThisMonth = false;
      },
      error: (err) => {
        console.error('Error loading this month stats:', err);
        this.loadingThisMonth = false;
      }
    });
  }

  loadLastMonthStats() {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const to = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);

    this.grnService.getStats(from, to).subscribe({
      next: (stats) => {
        this.lstMonthStats = { ...stats, date: from };
        this.loadingLastMonth = false;
      },
      error: (err) => {
        console.error('Error loading last month stats:', err);
        this.loadingLastMonth = false;
      }
    });
  }

  loadLast6MonthsStats() {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth() - 6, 1);
    const to = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);

    this.grnService.getStats(from, to).subscribe({
      next: (stats) => {
        this.last6MonthsStats = { ...stats, date: from };
        this.loadingLast6Months = false;
      },
      error: (err) => {
        console.error('Error loading last 6 months stats:', err);
        this.loadingLast6Months = false;
      }
    });
  }
  formatNumberWithNotation(num: number, decimals: number = 2): string {
        if (num === 0) return '0';

        const absNum = Math.abs(num);
        const sign = num < 0 ? '-' : '';

        if (absNum >= 1000000000) {
            return sign + (absNum / 1000000000).toFixed(decimals) + 'B';
        }

        if (absNum >= 1000000) {
            return sign + (absNum / 1000000).toFixed(decimals) + 'M';
        }

        if (absNum >= 10000) {
            return sign + (absNum / 1000).toFixed(decimals) + 'K';
        }

        return  sign + absNum.toString();
    }
}
export interface PurchaseHistoryStat {
    date: Date;
    grnCount: number;
    itemCount: number;
    unitCount: number;
    totalCost: number;
}
